import {connect} from 'react-redux';
import React, {Component} from 'react';
import Layout from '../Base/Layout';
import {Link} from 'react-router-dom';
import {translate} from '../../utils/i18n'

class AgreementPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ownerPartActive: true,

            editorActive: false,
            hasChange: false,
            htmlContent: null
        };

        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.editorRef.current && !this.editorRef.current.contains(event.target)) {

            this.onFinish();
        }
    }

    render() {
        let {ownerPartActive} = this.state;
        let {i18n} = this.props;
        let ownerClass = ownerPartActive ? "active" : "";
        let clientClass = !ownerPartActive ? "active" : "";
        let currentHtml = this.state.htmlContent;
        if (currentHtml == null && this.props.agreement != null) {
            currentHtml = ownerPartActive ? this.props.agreement.ownerContent : this.props.agreement.clientContent
        }

        return (
            <Layout
                title={translate('agreementPage.document.title', i18n) !== undefined ? translate('agreementPage.document.title', i18n) : ''}
            >
                <div className="clearfix container">
                    <div className="clearfix white_box add_container conv-blc">
                        <Link to="/" className="cancel">  {translate('agreementPage.back', i18n)}</Link>
                        <div className="clearfix heading">
                            <h2>
                                {translate('agreementPage.title', i18n)}
                            </h2>
                        </div>
                        <nav className="i-tab">
                            <a href="" className={ownerClass} onClick={(e) => {
                                e.preventDefault();

                                this.setState({ownerPartActive: true});
                            }}>
                                <i className="icon-tabs"/>
                                {translate('agreementPage.forOwner', i18n)}
                            </a>
                            <a href="" className={clientClass} onClick={(e) => {
                                e.preventDefault();

                                this.setState({ownerPartActive: false});
                            }}>
                                <i className="icon-tabs icon-mn"/>
                                {translate('agreementPage.forClient', i18n)}
                            </a>
                        </nav>

                        <div dangerouslySetInnerHTML={{__html: currentHtml}} style={{minHeight: '100px'}}/>
                    </div>
                </div>
            </Layout>
        )
    }
}


const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    agreement: state.configuration.agreement,
    currentUser: state.user.currentUser,
    languageCode: state.languages.currentLanguage.code
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(AgreementPage);



// WEBPACK FOOTER //
// ./src/components/Agreement/AgreementPage.js